import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { AppAlert, createAlertStore } from './alertStore';

const AlertsContext = createContext<ReturnType<typeof createAlertStore> | null>(
  null,
);
export function AlertsProvider({ children }: { children: ReactNode }) {
  const [store] = useState(createAlertStore);
  return (
    <AlertsContext.Provider value={store}>{children}</AlertsContext.Provider>
  );
}
export const useAlerts = () => useContext(AlertsContext);

export function useAlertsAccount(userId?: string) {
  const store = useAlerts();
  useLayoutEffect(() => {
    store?.setAccount(userId);
  }, [store, userId]);
}

export function useAlertSource(
  userId: string,
  source: string,
  entries: AppAlert[],
) {
  const store = useAlerts();
  useEffect(() => {
    store?.replace(userId, source, entries);
  });
  useEffect(
    () => () => {
      store?.remove(userId, source);
    },
    [store, userId, source],
  );
}
